import Minze, { MinzeElement, Reactive, EventListeners } from 'minze'
import { MODALS } from '../../constants'
import MainModule from '../../modules/main'
import { Locale } from '../../modules/locale'

Locale.getInstance().registerKeySet('fr', 'forgotPassword', {
  title: 'Mot de passe oublié?',
})

Locale.getInstance().registerKeySet('en', 'forgotPassword', {
  title: 'Forgot password?',
})

export interface LvcForgotPassword {}

export class LvcForgotPassword extends MinzeElement {
  modalId = MODALS.FORGOT_PASSWORD

  onReady(): void | Promise<void> {}

  goBack = () => {
    const mainModule = MainModule.getInstance()
    const routing = mainModule.getRouting()
    const lang = mainModule.getLang()

    routing.goToLastPage()
  }

  html = () => `
    <lvc-modal modal-id="${this.modalId}" narrow="true" modal-title="${Locale.getKey('forgotPassword.title')}" background="transparent">
      <div slot="lvc-modal-top">
        <lvc-box color="#1E007D" display="flex" alignItems="center" id="link-back">
          <lvc-chevron-left-icon></lvc-chevron-left-icon>
          <lvc-box mt="-4px">
            <lvc-text font-preset="small">${Locale.getKey('general.previous')}</lvc-text>
          </lvc-box>
        </lvc-box>
      </div>
      <div slot="lvc-modal-content">
        <lvc-forgot-password-content></lvc-forgot-password-content>
      </div>
    </lvc-modal>
  `

  css = () => `
    :host {

    }
    #link-back {
      cursor: pointer;
    }


  `

  eventListeners: EventListeners = [['#link-back', 'click', this.goBack]]
}
